import React from "react"
import { Box, Card, CardContent, CircularProgress, Divider, Grid, Tooltip, Typography } from "@mui/material"
import type { AverageTimesProps } from "..";
import { useLang } from "~/hooks/useLang";
import HelpIcon from '@mui/icons-material/Help';
interface ShowAverageDispatchClosingTimeProps {
  readonly averageTime: AverageTimesProps | null;
}

export default function ShowAverageDispatchClosingTime({ averageTime }: ShowAverageDispatchClosingTimeProps) {
  const { translate } = useLang();

  return (
    <Card>
      <CardContent sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>

        <Grid item xs={3} marginLeft={2}>
          {averageTime?.AverageDispatchTotalTime.loadingInfo ?
            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <CircularProgress />
            </Box>
            :
            averageTime?.AverageDispatchTotalTime?.time ?
              <>
                <Typography noWrap={true} sx={{ display: 'flex', alignItems: 'center' }}>
                  {averageTime?.AverageDispatchTotalTime?.name}
                  <Tooltip title={translate('Time between creation and completion')} sx={{ marginLeft: 1 }}>
                    <HelpIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography variant="h2">
                  {averageTime?.AverageDispatchTotalTime?.time}
                </Typography>
              </>
              :
              <Typography sx={{ padding: '16px' }}>
                {translate('No data available')}
              </Typography>
          }
        </Grid>

        <Divider orientation="vertical" flexItem />

        <Grid item xs={3} marginLeft={2}>
          {averageTime?.AverageDispatchTime.loadingInfo ?
            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <CircularProgress />
            </Box>
            :
            averageTime?.AverageDispatchTime?.time ?
              <>
                <Typography noWrap={true} sx={{ display: 'flex', alignItems: 'center' }}>
                  {averageTime?.AverageDispatchTime?.name}
                  <Tooltip title={translate('Time between creation and commitment of a device')} sx={{ marginLeft: 1 }}>
                    <HelpIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography variant="h2">
                  {averageTime?.AverageDispatchTime?.time}
                </Typography>
              </>
              :
              <Typography sx={{ padding: '16px' }}>
                {translate('No data available')}
              </Typography>
          }
        </Grid>

        <Divider orientation="vertical" flexItem />

        <Grid item xs={3} marginLeft={2}>
          {averageTime?.AverageDisplacementTime.loadingInfo ?
            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <CircularProgress />
            </Box>
            :
            averageTime?.AverageDisplacementTime?.time ?
              <>
                <Typography noWrap={true} sx={{ display: 'flex', alignItems: 'center' }}>
                  {averageTime?.AverageDisplacementTime?.name}
                  <Tooltip title={translate('Time between creation and arrival on site')} sx={{ marginLeft: 1 }}>
                    <HelpIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography variant="h2">
                  {averageTime?.AverageDisplacementTime?.time}
                </Typography>
              </>
              :
              <Typography sx={{ padding: '16px' }}>
                {translate('No data available')}
              </Typography>
          }
        </Grid>

        <Divider orientation="vertical" flexItem />

        <Grid item xs={3} marginLeft={2}>
          {averageTime?.AverageDispatchFinishTime.loadingInfo ?
            <Box width={'100%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
              <CircularProgress />
            </Box>
            :
            averageTime?.AverageDispatchFinishTime?.time ?
              <>
                <Typography noWrap={true} sx={{ display: 'flex', alignItems: 'center' }}>
                  {averageTime?.AverageDispatchFinishTime?.name}
                  <Tooltip title={translate('Time between arrival at the site and completion')} sx={{ marginLeft: 1 }}>
                    <HelpIcon fontSize="small" />
                  </Tooltip>
                </Typography>
                <Typography variant="h2">
                  {averageTime?.AverageDispatchFinishTime?.time}
                </Typography>
              </>
              :
              <Typography sx={{ padding: '16px' }}>
                {translate('No data available')}
              </Typography>
          }
        </Grid>
      </CardContent>
    </Card>
  )
}